<div class="otp-container">
    <img src="assets/images/EF_logo-login.png" class="otp-logo">

    <p class="otp-title">Enter the 6-digit verification code sent to your phone.</p>

    <div class="otp-box-wrapper">
        <input *ngFor="let box of boxes; let i = index" #otpBox maxlength="1" type="text" class="otp-input"
            [(ngModel)]="otpDigits[i]" (keyup)="moveToNext($event, i)" id="otpcode{{i}}" name="otpcode{{i}}"/>
    </div>

    <button class="verify-btn" (click)="verifyOtpClicked()" [disabled]="mLoading">
        VERIFY CODE
    </button>

    <!-- Resend button with countdown -->
    <div class="resend-container">
    <span 
        class="resend-link" 
        [class.disabled]="!mCanResend"
        (click)="mCanResend && resendMultiFactorOtp()">
        Resend Code <span *ngIf="!mCanResend">({{ resendCountdown }}s)</span>
    </span>
</div>

    <div id="passwordResetPopup" [class.show]="mDisplayErrorPopup">
        {{ mError }}
    </div>
</div>